(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@material-ui/core/styles", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@material-ui/core/styles"), require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.styles, global.react);
    global.withStyleProvider = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _styles, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.withStyleProvider = withStyleProvider;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
  var generateClassName = (0, _styles.createGenerateClassName)({
    productionPrefix: "liveview-module-css-" // 원하는 프리픽스를 설정
  });

  function withStyleProvider(WrappedComponent) {
    return function (props) {
      // 스타일이나 테마 관련 로직이 여기 들어갈 수 있습니다.
      return /*#__PURE__*/_react["default"].createElement(_styles.StylesProvider, {
        generateClassName: generateClassName
      }, /*#__PURE__*/_react["default"].createElement(WrappedComponent, props));
    };
  }
});